import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/senior-tech-help")({
  beforeLoad: () => {
    throw redirect({ href: "/services/tech-support-for-seniors", statusCode: 301 });
  },
});
